<template>
  <div
    class="homeCompeticoesContainer"
    :class="{ recolhido: recolhido }"
  >
    <button
      type="button"
      class="homeCompeticoesAbrir"
      @click="aberto = true"
    >
      <i class="fa fa-filter" aria-hidden="true"></i>
      <span>Competições</span>
      <small>{{ selecionadas.length }}/{{ competicoes.length }}</small>
    </button>

    <button
      v-if="recolhido"
      type="button"
      class="homeCompeticoesReabrir"
      @click="$emit('recolher')"
    >
      <i class="fa fa-filter" aria-hidden="true"></i>
      <span>Mostrar competições</span>
      <small>{{ selecionadas.length }}/{{ competicoes.length }}</small>
    </button>

    <div
      class="homeCompeticoesDialog"
      :class="{ ativo: aberto }"
      :role="aberto ? 'dialog' : null"
      :aria-modal="aberto ? 'true' : null"
      aria-label="Selecionar competições"
      @click.self="aberto = false"
    >
      <aside class="homeCompeticoesFiltro" aria-label="Filtro de competições">
        <header class="homeCompeticoesCabecalho">
          <div>
            <strong>Competições</strong>
            <small>{{ selecionadas.length }} de {{ competicoes.length }}</small>
          </div>
          <div class="homeCompeticoesAcoes">
            <button
              type="button"
              class="homeCompeticoesAlternar"
              @click="$emit('alternar-todas')"
            >
              {{ selecionadas.length ? "Limpar" : "Todas" }}
            </button>
            <button
              type="button"
              class="homeCompeticoesRecolher"
              title="Recolher competições"
              aria-label="Recolher competições"
              @click="$emit('recolher')"
            >
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="homeCompeticoesFechar"
              title="Fechar"
              aria-label="Fechar competições"
              @click="aberto = false"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </header>

        <label class="homeCompeticoesBusca">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input
            v-model.trim="busca"
            type="search"
            placeholder="Buscar competição"
            aria-label="Buscar competição"
          />
          <button
            v-if="busca"
            type="button"
            title="Limpar busca"
            aria-label="Limpar busca de competição"
            @click="busca = ''"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </label>

        <div class="homeCompeticoesLista">
          <label
            v-for="competicao in competicoesVisiveis"
            :key="competicao.nome"
            class="homeCompeticaoItem"
          >
            <input
              type="checkbox"
              :checked="selecionadas.includes(competicao.nome)"
              @change="$emit('alternar', competicao.nome)"
            />
            <img :src="competicao.bandeira" alt="" />
            <span>{{ competicao.nome }}</span>
            <small>{{ competicao.quantidade }}</small>
          </label>

          <p v-if="!competicoesVisiveis.length">
            Nenhuma competição encontrada
          </p>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCompeticoesFiltro",
  props: {
    competicoes: { type: Array, default: () => [] },
    recolhido: { type: Boolean, default: false },
    selecionadas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aberto: false,
      busca: "",
    };
  },
  computed: {
    competicoesVisiveis() {
      var termo = this.normalizarTexto(this.busca);

      if (!termo) {
        return this.competicoes;
      }

      return this.competicoes.filter((competicao) =>
        this.normalizarTexto(competicao.nome).includes(termo)
      );
    },
  },
  methods: {
    normalizarTexto(valor) {
      return (valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("pt-BR");
    },
  },
};
</script>

<style>
.homeLegadoGrade {
  align-items: start;
  display: grid;
  gap: 18px;
  grid-template-areas: "principal competicoes";
  grid-template-columns: minmax(0, 1fr) 280px;
  margin: 0 auto;
  max-width: 1110px;
  width: 100%;
}

.homeLegadoPrincipal {
  grid-area: principal;
  min-width: 0;
}

.homeLegadoGradeRecolhida {
  grid-template-areas:
    "competicoes"
    "principal";
  grid-template-columns: minmax(0, 1fr);
}

.homeCompeticoesContainer {
  grid-area: competicoes;
  margin-top: 10px;
  position: sticky;
  top: 16px;
}

.homeCompeticoesAbrir,
.homeCompeticoesReabrir {
  display: none;
}

.homeCompeticoesDialog {
  display: block;
}

.homeCompeticoesFiltro {
  background: #ffffff;
  border: 1px solid #d8dde1;
  border-radius: 3px;
  overflow: hidden;
}

.homeCompeticoesCabecalho {
  align-items: center;
  border-bottom: 1px solid #dfe3e6;
  display: flex;
  justify-content: space-between;
  padding: 11px 12px;
  text-align: left;
}

.homeCompeticoesCabecalho > div {
  display: flex;
  flex-direction: column;
}

.homeCompeticoesCabecalho strong {
  font-size: 12px;
}

.homeCompeticoesCabecalho small {
  color: #748089;
  font-size: 9px;
  margin-top: 2px;
}

.homeCompeticoesAcoes {
  align-items: center;
  display: flex;
  gap: 5px;
}

.homeCompeticoesCabecalho button {
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 4px;
}

.homeCompeticoesAlternar {
  color: #237a58;
  font-size: 10px;
}

.homeCompeticoesRecolher {
  align-items: center;
  color: #6e7880;
  display: inline-flex;
  font-size: 15px;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.homeCompeticoesFechar {
  color: #6e7880;
  display: none;
  font-size: 14px;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.homeCompeticoesBusca {
  border-bottom: 1px solid #e2e6e9;
  display: flex;
  margin: 0;
  padding: 8px;
  position: relative;
}

.homeCompeticoesBusca > i {
  color: #7b858d;
  font-size: 11px;
  left: 17px;
  position: absolute;
  top: 19px;
}

.homeCompeticoesBusca input {
  border: 1px solid #ced4da;
  border-radius: 2px;
  font-size: 10px;
  height: 32px;
  padding: 5px 30px 5px 27px;
  width: 100%;
}

.homeCompeticoesBusca button {
  background: transparent;
  border: 0;
  color: #79838b;
  cursor: pointer;
  height: 30px;
  position: absolute;
  right: 9px;
  top: 9px;
  width: 28px;
}

.homeCompeticoesLista {
  max-height: 430px;
  overflow-y: auto;
}

.homeCompeticaoItem {
  align-items: center;
  border-bottom: 1px solid #edf0f2;
  cursor: pointer;
  display: grid;
  gap: 7px;
  grid-template-columns: 14px 18px minmax(0, 1fr) 24px;
  margin: 0;
  min-height: 36px;
  padding: 7px 10px;
  text-align: left;
}

.homeCompeticaoItem:hover {
  background: #f5f7f8;
}

.homeCompeticaoItem input {
  accent-color: #2d996a;
  height: 12px;
  margin: 0;
  width: 12px;
}

.homeCompeticaoItem img {
  border: 1px solid #d4d9dd;
  height: 12px;
  object-fit: cover;
  width: 18px;
}

.homeCompeticaoItem span {
  font-size: 10px;
  line-height: 1.25;
  min-width: 0;
}

.homeCompeticaoItem small {
  background: #eef1f3;
  color: #69747c;
  font-size: 9px;
  padding: 2px 4px;
  text-align: center;
}

.homeCompeticoesLista > p {
  color: #7a858d;
  font-size: 10px;
  margin: 0;
  padding: 20px 12px;
  text-align: center;
}

@media (min-width: 901px) {
  .homeCompeticoesContainer.recolhido {
    margin-top: 0;
    position: static;
  }

  .homeCompeticoesContainer.recolhido .homeCompeticoesDialog {
    display: none;
  }

  .homeCompeticoesContainer.recolhido .homeCompeticoesReabrir {
    align-items: center;
    background: transparent;
    border: 1px solid #ced5d9;
    border-radius: 3px;
    color: #354149;
    display: inline-flex;
    font-size: 10px;
    font-weight: 600;
    gap: 7px;
    height: 34px;
    justify-self: end;
    padding: 0 10px;
  }

  .homeCompeticoesReabrir small {
    background: #eef1f3;
    color: #66727a;
    font-size: 8px;
    padding: 2px 5px;
  }
}

@media (max-width: 900px) {
  .homeLegadoGrade {
    grid-template-areas:
      "competicoes"
      "principal";
    grid-template-columns: minmax(0, 1fr);
  }

  .homeCompeticoesContainer {
    margin-top: 0;
    order: -1;
    position: static;
  }

  .homeCompeticoesAbrir {
    align-items: center;
    background: transparent;
    border: 1px solid #ced5d9;
    border-radius: 3px;
    color: #354149;
    display: flex;
    font-size: 11px;
    font-weight: 600;
    gap: 7px;
    height: 38px;
    justify-content: center;
    padding: 0 12px;
    width: 100%;
  }

  .homeCompeticoesReabrir {
    display: none !important;
  }

  .homeCompeticoesAbrir small {
    background: #eef1f3;
    color: #66727a;
    font-size: 9px;
    padding: 2px 5px;
  }

  .homeCompeticoesDialog {
    align-items: center;
    background: rgba(18, 22, 25, 0.68);
    bottom: 0;
    display: none;
    justify-content: center;
    left: 0;
    padding: 12px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1080;
  }

  .homeCompeticoesDialog.ativo {
    display: flex;
  }

  .homeCompeticoesFiltro {
    display: flex;
    flex-direction: column;
    max-height: min(680px, calc(100vh - 24px));
    width: min(430px, 100%);
  }

  .homeCompeticoesFechar {
    align-items: center;
    display: inline-flex;
  }

  .homeCompeticoesRecolher {
    display: none;
  }

  .homeCompeticoesLista {
    flex: 1;
    max-height: none;
  }
}
</style>
